var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.95V11C18 14.2998 18 15.9497 16.9745 16.9745C15.9504 18 14.2998 18 11 18C7.7002 18 6.0503 18 5.0248 16.9745C4 15.9504 4 14.2998 4 11C4 10.2104 4 9.5146 4.014 8.9M12.05 4H11C7.7002 4 6.0503 4 5.0248 5.0248C4.7168 5.3335 4.5005 5.6989 4.35 6.149",
    stroke: "#272E48",
    strokeWidth: 0.73,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.4001L8.7579 10.8909C9.2563 10.2924 9.5055 9.9935 9.8331 9.9935C10.1614 9.9935 10.4106 10.2924 10.909 10.8909L11.091 11.1093C11.5894 11.7078 11.8386 12.0067 12.1669 12.0067C12.4952 12.0067 12.7437 11.7078 13.2421 11.1093L14.5 9.6001",
    stroke: "#272E48",
    strokeWidth: 0.73,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8998 8.2C17.0596 8.2 17.9998 7.2598 17.9998 6.1C17.9998 4.9402 17.0596 4 15.8998 4C14.74 4 13.7998 4.9402 13.7998 6.1C13.7998 7.2598 14.74 8.2 15.8998 8.2Z",
    stroke: "#272E48",
    strokeWidth: 0.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartData);
export default __webpack_public_path__ + "static/media/chart_data.5700895d73fb2402902ccce27e1a21ec.svg";
export { ForwardRef as ReactComponent };